import React from 'react';

export const Image = (props) => {
  return <img data-testid='img' alt='Alternate Text' {...props} />;
};
